import React, { PureComponent } from 'react'
import { FormControl, InputLabel, MenuItem, Select, Input } from '@material-ui/core'

import { isValidString } from '../../utils/string'

import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'
import ModalDialog from '../common/ModalDialog'

class AddComponentGroupModal extends PureComponent {
  state = {
    name: '',
    quantityType: '',
  }

  addComponentGroup = () => {
    const { name, quantityType } = this.state

    if (!isValidString(name)) {
      this.props.onError('Please provide a valid component group name')
      return
    }
    if (!isValidString(quantityType)) {
      this.props.onError('Please provide a valid component group quantity type')
      return
    }

    this.props.addComponentGroup({ name, active: true, quantityType })
  }

  onClose = () => {
    this.setState({
      name: '',
      quantityType: '',
    })
  }

  onOpen = (type) => {
    this.setState({
      name: '',
      quantityType: '',
    })
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  render() {
    const { forwardedRef } = this.props

    const { name, quantityType } = this.state

    return (
      <ModalDialog
        title={'Add Component Group'}
        ref={forwardedRef}
        onConfirm={this.addComponentGroup}
        onClose={this.onClose}
        onOpen={this.onOpen}
      >
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Name *</InputLabel>
          <Input
            name="name"
            value={name}
            onChange={this.onChange}
            fullWidth
            inputProps={{
              maxLength: 50,
            }}
          />
        </FormControl>
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Quantity type *</InputLabel>
          <Select value={quantityType} name="quantityType" onChange={this.onChange}>
            {this.props.quantityTypeList &&
              this.props.quantityTypeList.map((i) => <MenuItem value={i}>{i}</MenuItem>)}
          </Select>
        </FormControl>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(AddComponentGroupModal)



// WEBPACK FOOTER //
// ./src/components/Modal/AddComponentGroupModal.js